import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  Dialog,
  DialogContent,
  useMediaQuery,
  useTheme,
  IconButton,
  Autocomplete,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addBillingRequestApproval, getBillingList } from "redux/actions/BillingAction";
import CommonButton from "components/commonButton/CommonButton";
import linkIcon from "assets/images/Link.svg";

function ConfirmAndLinkModel(props) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [emails, setEmails] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const handleClose = () => {
    dispatch(getBillingList(props?.billingListpayloadData));
    props?.setSelectAllChecked(false);
    props?.setSelectedCheckRows([]);
    props.handleClose();
  };

  const linkResponse = useSelector(
    (state) => state.addBillingRequestApprovalLink?.bilingApprovalRequestLink?.data
  );

  const companyProfile = useSelector(
    (state) => state?.userCompanyDetails?.companyDetails?.Employees
  );

  useEffect(() => {
    if (companyProfile) {
      // Extract emails from company profile
      const defaultEmails = companyProfile
        .map((employee) => employee.email)
        .filter((email) => isValidEmail(email)); // Validate emails

      setEmails(defaultEmails); // Set the default emails
    }
  }, [companyProfile]);

  const handleGmail = () => {
    // const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${linkResponse?.toEmail}&su=${linkResponse?.emailSubject}&body=${linkResponse?.emailBody}`
    // window.open(gmailComposeUrl, "_blank");
    const paylaod = {
      "invoiceIds": props?.totalAmount?.id,
      'receipientEmails':emails,
      companyId:props?.billingFilter?.parentCompanyName?.value,
    }
    dispatch(addBillingRequestApproval(paylaod,''));
    handleClose();
  };

 // Function to validate email
 const isValidEmail = (email) => {
  // Trim email and check if it has valid format and no spaces inside
  const trimmedEmail = email.trim();
  const isValid = /\S+@\S+\.\S+/.test(trimmedEmail) && !/\s/.test(trimmedEmail);
  return isValid ? trimmedEmail : false; // Return trimmed email if valid, otherwise false
};

const handleAddEmail = (event, newValue) => {
  // Map through new emails and validate each one
  const validEmails = newValue
    .map((email) => isValidEmail(email)) // Validate and trim emails
    .filter(Boolean); // Keep only valid emails

  // Merge with the existing valid emails, avoiding duplicates
  setEmails((prevEmails) => [...new Set([...prevEmails, ...validEmails])]);

  // Clear input after adding valid emails
  setInputValue("");
};

  // Handle email removal when clicking the close icon on the Chip
  const handleRemoveEmail = (emailToRemove) => {
    setEmails((prevEmails) => prevEmails.filter((email) => email !== emailToRemove));
  };

  const handleText = () => {
    navigator.clipboard.writeText(linkResponse?.requestUrl);
    toast.success("Copied Successfully");
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={props.open || false}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      className="p20"
    >
      <DialogContent className="w500">
        <Box className="justifyBetween">
          <Typography
            variant={"head3"}
            className="titleStyle fw700 colorPrimary"
          >
          Share with&nbsp;
          {props?.companyName?.length <= 15 && <span className="colorSecondary">{props?.companyName || "NA"}</span>} 
          </Typography>
          <Box className="pl10">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className="modelCloseIcon"
          >
            <CloseIcon />
          </IconButton>
          </Box>
        </Box>
        <Typography className="colorSecondary titleStyle fw700 mb10" component={"p"}
        variant={"head3"}>
          {props?.companyName?.length > 15 && <span>{props?.companyName || "NA"}</span> }
        </Typography>

        <Grid container item md={12} className="mb10">
          <TextField
            className="ml10 width100"
            placeholder="Share Link"
            inputProps={{ "aria-label": "Share Link" }}
            disabled={true}
            value={linkResponse?.requestUrl || ""}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" onClick={handleText}>
                  <IconButton>
                    <img src={linkIcon} alt="linkLogo" className="link" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Autocomplete
      multiple
      disableClearable
      freeSolo
      options={[]} // No predefined options, free entry
      value={emails}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
      onChange={handleAddEmail}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip key={index} label={option} {...getTagProps({ index })} onDelete={() => handleRemoveEmail(option)}  />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder="Add email"
          onKeyDown={(event) => {
            if ( event.key === ",") {
              event.preventDefault(); // Prevent default behavior for Enter and Comma
              const validEmail = isValidEmail(inputValue); // Validate input
              if (validEmail) {
                // If the email is valid, add it to the list
                setEmails((prevEmails) => [...new Set([...prevEmails, validEmail])]); // Add valid email
              } 
              setInputValue(""); // Clear input in both cases
            }
          }}
        />
      )}
    />
        <Box className="flexend mt20">
          <CommonButton
            name={"Send via email"}
            type="submit"
            btnClass="btnSm"
            onClick={handleGmail}
            disabled={emails.length === 0}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default ConfirmAndLinkModel;
